import React from 'react'

import ReadOnlyApplicationStatus from 'components/ReadOnlyStatusHeader/ReadOnlyApplicationStatus'
import ErrorPage from 'pages/ErrorPage'
import LoadingPage from 'pages/LoadingPage/LoadingPage'

import { ApplicationStatusProps } from '../hooks/useReadOnlyApplication'

interface ReadOnlyWrapperProps {
    loading: boolean
    error: Error | null
    appStatus: ApplicationStatusProps
    applicantName: string
    id: string | undefined
    children: React.ReactNode
}

export default function ReadOnlyWrapper({
    loading,
    error,
    appStatus,
    applicantName,
    id,
    children,
}: ReadOnlyWrapperProps) {
    if (loading) {
        return <LoadingPage />
    }

    if (error) {
        return (
            <ErrorPage
                title="Failed to load application"
                body={
                    'An error occurred when trying to load the application. ' +
                    'Please try again. If the problem persists, contact us.'
                }
                errorData={{ error, context: { application: { id } } }}
            />
        )
    }

    return (
        <>
            <ReadOnlyApplicationStatus
                id={appStatus.id}
                applicant={applicantName}
                status={appStatus.status}
                lender={appStatus.lender_name}
                submittedAt={appStatus.submitted_at}
                createdAt={appStatus.created}
                hasActiveContracts={appStatus.has_active_contracts}
                redecisionBlockers={appStatus.redecision_blockers}
            />
            {children}
        </>
    )
}
